/* FTE Report's horizontal filter bar — same control set/behavior AOP Budget's own filter bar
   uses (Select / GlobalMultiSelectFilter, switched on f.type). The Date Range picker lives
   outside this bar, in the content area below the page header — same position "Actuals Vs
   Forecast by Date Range" uses it in (see FTEReport.js), not here. */
import React from "react";
import { FilterApplyButton, HorizontalDateRangeFilter } from "../GlobalFilterPanel";
import {
  getFilterFieldOptions,
  toFilterSelectOptions,
  FILTER_SELECT_SEARCH_PROPS,
  GlobalMultiSelectFilter,
} from "../filterRelationshipUtils";
import { filtersForKeys } from "./fteReportFilterHelpers";

export default function FTEReportFilterBar({
  visibleKeys,
  draft,
  dropdownOptions,
  onChange,
  onClearAll,
  onApply,
  onClose,
  classes,
  clearAllDisabled,
  applyDisabled,
}) {
  const filters = filtersForKeys(visibleKeys);
  const selectStyle = { minWidth: 110, maxWidth: 180, fontSize: 12 };

  return (
    <div className={classes.hFilterBar}>
      {filters.map((f) => {
        const val = draft[f.key];
        if (f.type === "daterange") {
          return (
            <div key={f.key} className={classes.hFilterGroup}>
              <span className={classes.hFilterLabel}>{f.label}</span>
              <HorizontalDateRangeFilter value={val} onChange={(next) => onChange(f.key, next)} />
            </div>
          );
        }
        const opts = toFilterSelectOptions(f.key, getFilterFieldOptions(f, dropdownOptions));
        return (
          <div key={f.key} className={classes.hFilterGroup}>
            <span className={classes.hFilterLabel}>{f.label}</span>
            <GlobalMultiSelectFilter
              size="small"
              style={selectStyle}
              value={val}
              options={opts}
              onChange={(v) => onChange(f.key, v)}
              {...FILTER_SELECT_SEARCH_PROPS}
              popupMatchSelectWidth={false}
            />
          </div>
        );
      })}
      <div className={classes.hFilterActions}>
        <button className={classes.hFilterClearAll} onClick={onClearAll} disabled={clearAllDisabled}>
          Clear All
        </button>
        <FilterApplyButton draft={draft} onApply={onApply} className={classes.hFilterApply} disabled={applyDisabled}>
          Apply
        </FilterApplyButton>
      </div>
      <button className={classes.hFilterClose} onClick={onClose} title="Close Filters">
        ✕
      </button>
    </div>
  );
}
